/*
  Vorbestellungs-Hinweis auf der Produktseite.

  Schaltet Liefer-Chip, Hinweisbox und Button-Text um, wenn der Kunde die
  Variante wechselt - ohne Seitenreload.

  Datenquelle ist das von Liquid gerenderte <script type="application/json"
  data-gp-preorder-map>. Dort steht pro Varianten-ID { pre, date }: Vorbestellung
  per Variantenmetafeld custom.vorbestellung_versand (Datum, trotz Bestand) oder
  alt per Bestand <= 0 und Policy "continue". Schaltet auch das Feld
  properties[Vorbestellung] (geht in Warenkorb und Bestellung).

  Hinweis: Das Theme dokumentiert ein Event "VARIANT_CHANGE" auf <product-form>,
  feuert es aber nicht zuverlaessig - form._event ist je nach Konfiguration
  undefined. Deshalb wird zusaetzlich auf das bubbelnde "change" gehoert.
*/
(function () {
  'use strict';

  function init(mapEl) {
    var root = mapEl.closest('.product') || mapEl.closest('[id^="product-"]') || document;
    var form = root.querySelector('product-form') || document.querySelector('product-form');
    if (!form) { return; }

    var cfg;
    try { cfg = JSON.parse(mapEl.textContent); } catch (e) { return; }
    if (!cfg || !cfg.variants) { return; }

    var chipStock = root.querySelector('[data-gp-chip-stock]');
    var chipPre = root.querySelector('[data-gp-chip-preorder]');
    var note = root.querySelector('[data-gp-preorder-note]');
    var btn = root.querySelector('[data-js-product-add-to-cart]');
    var btnText = root.querySelector('[data-js-product-add-to-cart-text]');

    function toggle(el, hidden) {
      if (!el) { return; }
      if (hidden) { el.setAttribute('data-gp-hidden', ''); }
      else { el.removeAttribute('data-gp-hidden'); }
    }

    var lastId = null;

    function apply() {
      var input = form.querySelector('input[name="id"]');
      var id = input ? String(input.value) : null;
      if (!id) { return; }

      // Map-Eintrag: alt true/false, neu { pre, date } (Datum je Variante aus Metafeld custom.vorbestellung_versand)
      var entry = cfg.variants[id];
      var pre = entry === true || !!(entry && entry.pre);
      var date = (entry && entry.date) || cfg.date;
      var dates = root.querySelectorAll('[data-gp-date]');
      for (var d = 0; d < dates.length; d++) { dates[d].textContent = date; }
      var prop = root.querySelector('[data-gp-preorder-prop]') || form.querySelector('[data-gp-preorder-prop]');
      if (prop) {
        prop.disabled = !pre;
        prop.value = 'Versand voraussichtlich ab ' + date;
      }

      // Lieferzeit-Chip nur bei lieferbarer Variante (vorher auch bei ausverkauften: „Lieferung in 1–3 Tagen“)
      var atcBtn = form.querySelector('[data-js-product-add-to-cart]');
      var soldOut = !pre && atcBtn && atcBtn.disabled;
      toggle(chipStock, pre || soldOut);
      toggle(chipPre, !pre);
      toggle(note, !pre);

      // Ausverkaufte Varianten behalten ihren "Ausverkauft"-Text.
      var soldOut = btn && btn.hasAttribute('disabled');
      if (btnText && !soldOut) {
        btnText.textContent = pre ? 'Jetzt vorbestellen' : 'Ab ins Warenkörbchen';
      }
      lastId = id;
    }

    function schedule() {
      window.setTimeout(apply, 60);
    }

    form.addEventListener('VARIANT_CHANGE', schedule);
    root.addEventListener('change', schedule, true);
    document.addEventListener('change', schedule, true);

    // Fallback: manche Themes tauschen den Buy-Bereich per JS aus, ohne dass
    // ein Event ankommt. Kurzes Nachfassen faengt das ab.
    window.setInterval(function () {
      var input = form.querySelector('input[name="id"]');
      if (input && String(input.value) !== lastId) { apply(); }
    }, 500);

    apply();
  }

  function boot() {
    var maps = document.querySelectorAll('[data-gp-preorder-map]');
    for (var i = 0; i < maps.length; i++) { init(maps[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
